module.exports = __webpack_public_path__ + "media/entities/5205-cf993bd6.png";